import IntraserLogo from 'assets/icons/tenant/intraser-logo.svg';
import XPOLogo from 'assets/icons/xpo/xpo-logo.jpg';
import RPTLogo from 'assets/icons/rpt/rpt-logo.jpg';
import CEXLogo from 'assets/icons/cex/cex-logo.svg';
import OntruckLogo from 'assets/icons/ontruck-logo.svg';
import OnTimeLogo from 'assets/icons/ontime/ontime-logo.svg';
import AlianzaLogo from 'assets/icons/alianza/alianza-logo.svg';
import { getTenantPreLoginConfig } from 'tenant/teanantPreLoginConfig';
import { TENANTS_NAMES } from 'tenant/host_config';

export const MenuIcon = () => {
  const iconConfig = getTenantPreLoginConfig().menu_icon;

  const Icons = {
    [TENANTS_NAMES.ontruck]: OntruckLogo,
    [TENANTS_NAMES.intraser]: IntraserLogo,
    [TENANTS_NAMES.xpo]: XPOLogo,
    [TENANTS_NAMES.rpt]: RPTLogo,
    [TENANTS_NAMES.cex]: CEXLogo,
    [TENANTS_NAMES.ontime]: OnTimeLogo,
    [TENANTS_NAMES.alianza]: AlianzaLogo,
  };

  return Icons[iconConfig];
};
